import { AfterViewInit, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'cygov-average-box',
  templateUrl: './average-box.component.html',
  styleUrls: ['./average-box.component.scss'],
  standalone: false,
})
export class AverageBoxComponent implements OnInit, AfterViewInit {
  @ViewChild('averageBox') averageBox: ElementRef;
  @Input() average: number = 0;
  @Input() total: number = 10;
  private readonly SVG_BOX_WIDTH = 140;
  SVG_BOX_HEIGHT: number;
  averageBoxPath: string;
  TEXT_START_Y: number;
  viewBox: string = '0 0 140 24';
  className: string = '';
  constructor() {}

  ngOnInit(): void {
    this.getScoreClass();
  }

  ngAfterViewInit(): void {
    // Recompute after view init so the path follows actual rendered height.
    this.updateSvgDimensions();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateSvgDimensions();
  }

  private updateSvgDimensions(): void {
    const containerHeight = this.averageBox?.nativeElement?.offsetHeight;
    this.SVG_BOX_HEIGHT = containerHeight > 0 ? containerHeight : 24;
    const middleY = this.SVG_BOX_HEIGHT / 2;
    const bottomY = this.SVG_BOX_HEIGHT;
    this.averageBoxPath =
      `M 0 0 L ${this.SVG_BOX_WIDTH} 0 L 120 ${middleY} ` +
      `L ${this.SVG_BOX_WIDTH} ${bottomY} L 0 ${bottomY} L 20 ${middleY} z`;
    this.TEXT_START_Y = this.SVG_BOX_HEIGHT / 2;
    this.viewBox = `0 0 ${this.SVG_BOX_WIDTH} ${this.SVG_BOX_HEIGHT}`;
  }

  getScoreClass(): void {
    switch (true) {
      case this.average <= 3.33:
        this.className = 'low-stroke';
        break;
      case this.average < 6.66:
        this.className = 'medium-stroke';
        break;
      case this.average >= 7.66:
        this.className = 'high-stroke';
        break;
    }
  }
}
